// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__20MBR","icons":"Contact_icons__gat8D","icon":"Contact_icon__gLUOf","footer":"Contact_footer__22s-+"};